<template>
  <a-button @click="visible = true" v-if="typebtn !== 'text'" :type="typebtn">签约成功</a-button>
  <a
      v-if="typebtn == 'text'"
      href="javascript:void(0);"
      type="link"
      @click="visible = true"
      class="theme-color"
      style="color: #2F7BFF"
    >
      签约成功
    </a>
    <a-modal
      :centered="true"
      :keyboard="false"
      :mask-closable="false"
      v-model:visible="visible"
      :width="750"
      title="签约成功"
      ok-text="确认"
      cancel-text="取消"
      @ok="uploadFilesFn"
    >
      <upload-file-table
        ref="attachRef"
        v-model:value="attachList"
        :allow-edit="true"
        :biz-type="bizType"
      ></upload-file-table>
    </a-modal>
</template>

<script lang="ts">
import { PropType, defineComponent, reactive, ref, toRefs } from "vue";
import { BizFileService } from "@/core";
import { FileRecord } from "@/core/services/file-upload.interface";
import { SignService } from "./sign-contract-btn.service";
import { ContractBtnResp } from "../tear-contract-btn/tear-contract-btn.interface";
import { message } from "ant-design-vue";
import moment from "moment";
export default defineComponent({
  isGlobal: true,
  name: "SignContractBtn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizFileType: {
      type: String,
      required: true,
    },
    typebtn: {
      type: String,
      default: 'primary'
    },
    record: {
      type: Object as PropType<any>,
    },
    startDateKey: {
      type: String,
      default: 'startDate'
    },
  },
  emits: ["refresh"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive({
      visible: false,
      attachList: [] as FileRecord[],
    })
    const reqData = reactive({} as ContractBtnResp)
    const { run } = BizFileService.useCreateApi();
    const { run: successRun } = SignService.useContractStatusChangeApi();
    const uploadFilesFn = async () => {
      const files = state.attachList.map((item) => {
        item.name = item.name.replace(/(\.\w+)$/, '_签约新增$1');
        item.bizId = props.bizId ;
        item.bizType = props.bizType;
        return item;
      });
      let status= moment().isAfter(moment(props.record[props.startDateKey]))?'lyz':'dly'
      const res = await successRun(files, props.bizId, props.bizType, props.bizFileType,status);
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return;
      }
      message.success(res.respDesc);
      emit("refresh", null);
      state.visible = false
      state.attachList = []
      emit("refresh")
    };

    return { 
      ...toRefs(state),
      uploadFilesFn
    };
  },
});
</script>
